import React from 'react';
import Swal from 'sweetalert2';
import { File } from '../../../../components/IconsSVG';
import AdminDropdown from '../../../../partials/content/CustomDropdowns/AdminDropdown';
import CrudActions from '../../../../partials/datatable/CrudActions';
import Datatable from '../../../../partials/datatable/Datatable';
import { StyledTableCell, StyledTableRow } from '../../../../partials/datatable/styles';
import { MutantApiService } from '../../../../services/MutantApiService';
import store from '../../../../store/store';
import Loading from '../../../home/components/Loading';
import { format } from 'date-fns';

const initialState = {
	presets: [],
	reload: false,
	loading: true,
};

export default class PresetsListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user,
		};

		this.formatRow = this.formatRow.bind(this);
		this.setPresets = this.setPresets.bind(this);
		this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	setPresets = (presets) => {
		this.setState({ presets });
	};

	handleConfirmDelete = async (id) => {
		try {
			const reqBase = { method: "DELETE", url: `/presets/${id}` };

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
			
			await Swal.fire({
				title: 'Sucesso!',
				text: 'Preset deletado com sucesso.',
				icon: 'success',
			});
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao deletar o preset, tente mais tarde",
				"error"
			);
		}
	};

	formatRow(preset) {
		const crudActions = ["edit", "delete"];

		return (
			<StyledTableRow hover tabIndex={-1} key={preset.id}>
				<StyledTableCell scope="row" align="left">
					{preset.name}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left">
					{preset.volume.toFixed(2)}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left">
					{preset.silenceEdgeMs} ms
				</StyledTableCell>
				<StyledTableCell scope="row" align="left">
					{preset.createdAt ? format(new Date(preset.createdAt), 'dd/MM/yyyy HH:mm') : '-'}
				</StyledTableCell>
				<StyledTableCell scope="row" align="center">
					<CrudActions
						actions={crudActions}
						id={preset.id}
						module="presets"
						onConfirmDelete={this.handleConfirmDelete}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	}

	render() {
		const headRows = [
			{ label: "NOME", align: "left" },
			{ label: "VOLUME", align: "left" },
			{ label: "SILENCE EDGE", align: "left" },
			{ label: "DATA CRIAÇÃO", align: "left" },
			{ label: "AÇÕES", align: "center" },
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Presets"
					icon={File}
					endpoint="presets"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.presets}
					setRows={this.setPresets}
					reload={this.state.reload}
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
					notPaginated
					buttons={[
						{
							label: "Adicionar",
							onClick: () => {
								this.props.history.push("/dashboard/presets/new");
							},
							icone: "add",
						},
					]}
				/>
			</>
		);
	}
}
